import { SubscriptionStatus } from "../../../../../contracts/nexar-api/types";
import { SUBSCRIPTION_FORM_FIELDS } from "../formik/formik";
import Event from "../../../../../core/consts/analytics-events";
import { NexarApiContract } from "../../../../../contracts/nexar-api/nexar-api";
import { AnalyticsContract } from "../../../../../contracts/analytics/analytics";

export default async function ApiSubmission(
  nexarApi: NexarApiContract,
  analytics: AnalyticsContract | undefined,
  subscriptionId: string,
  formValues: any,
  tokenId: string,
  status: SubscriptionStatus
) {
  const action =
    status === "ACTIVE"
      ? nexarApi.updateSubscriptionById
      : nexarApi.activateSubscriptionById;
  const firstName = formValues[SUBSCRIPTION_FORM_FIELDS.FIRST_NAME.key];
  const lastName = formValues[SUBSCRIPTION_FORM_FIELDS.LAST_NAME.key];
  const email = formValues[SUBSCRIPTION_FORM_FIELDS.EMAIL.key];
  const paymentDetails = { firstName, lastName, email, recurlyToken: tokenId };

  analytics?.track(Event.SubscriptionDetailsSubmitClicked, {
    subscriptionId,
    subscriptionStatus: status,
    firstName,
    lastName,
    email,
  });

  const { success: successFromResponse, error: errorFromResponse } =
    await action({
      subscriptionId,
      paymentDetails,
    });
  if (successFromResponse) {
    return;
  } else if (errorFromResponse) {
    throw errorFromResponse;
  }
}
